import React from "react";
import { Label } from "../../../../../ui/label";
import { Input } from "../../../../../ui/input";

/**
 * Lightweight field building blocks used by all section editors. Each takes
 * the RHF `form` instance (so we can read `formState.errors` cleanly) plus a
 * dotted path for the registered field.
 */

export const TextField = ({ form, path, label, hint, required, autoFocus }) => {
  const error = path
    .split(".")
    .reduce((acc, key) => acc?.[key], form.formState.errors);
  return (
    <div className="grid gap-1.5">
      <Label htmlFor={path}>
        {label}
        {required && <span className="text-destructive ml-1">*</span>}
      </Label>
      <Input id={path} autoFocus={autoFocus} {...form.register(path)} />
      {hint && <p className="text-xs text-muted-foreground">{hint}</p>}
      {error?.message && (
        <p className="text-xs text-destructive">{error.message}</p>
      )}
    </div>
  );
};

const LINE_BREAK_HINT = "Press Enter to add a line break.";

export const TextareaField = ({ form, path, label, rows = 4, hint, required }) => {
  const error = path
    .split(".")
    .reduce((acc, key) => acc?.[key], form.formState.errors);
  const composedHint = hint ? `${hint} ${LINE_BREAK_HINT}` : LINE_BREAK_HINT;
  return (
    <div className="grid gap-1.5">
      <Label htmlFor={path}>
        {label}
        {required && <span className="text-destructive ml-1">*</span>}
      </Label>
      <textarea
        id={path}
        rows={rows}
        className="flex w-full rounded-md border border-input bg-background px-3 py-2 text-sm ring-offset-background placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2"
        {...form.register(path)}
      />
      <p className="text-xs text-muted-foreground">{composedHint}</p>
      {error?.message && (
        <p className="text-xs text-destructive">{error.message}</p>
      )}
    </div>
  );
};
